<div class="row gx-0">
	<div class="col">
		<mat-card-header>
			<mat-card-title>
				Compare Children
				<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
					<mat-icon>close</mat-icon>
				</button>
			</mat-card-title>
		</mat-card-header>
	</div>
</div>
<div class="row gx-0">
	<div class="col-6">
		<mat-card-header>
			<mat-card-title>
				{{studentName1}} {{regions1}} <span class="danger h5">{{merged1}}</span> <span
					class="danger h5">{{terminated1}}</span>
				<mat-icon *ngIf="isLoading || !studentName1">
					<mat-spinner diameter="20"> </mat-spinner>
				</mat-icon>
			</mat-card-title>
		</mat-card-header>
	</div>
	<div class="col-6">
		<mat-card-header>
			<mat-card-title>
				{{studentName2}} {{regions2}} <span class="danger h5">{{merged2}}</span> <span
					class="danger h5">{{terminated2}}</span>
				<mat-icon *ngIf="isLoading || !studentName2">
					<mat-spinner diameter="20"> </mat-spinner>
				</mat-icon>
			</mat-card-title>
		</mat-card-header>
	</div>
</div>
<div class="row gx-0">
	<div class="col-12">
		<mat-card-content>
			<div *ngIf="!isLoading">

				<div class="row">
					<div class="col-6">
						<view-child-demographic [studentId]="studentId1"
							[studentHelperNumber]="1"></view-child-demographic>
					</div>
					<div class="col-6">
						<view-child-demographic [studentId]="studentId2"
							[studentHelperNumber]="2"></view-child-demographic>
					</div>
				</div>

				<div class="row margin-top-sm">
					<div class="col-6">
						<view-child-address-info [studentHelperNumber]="1"></view-child-address-info>
					</div>
					<div class="col-6">
						<view-child-address-info [studentHelperNumber]="2"></view-child-address-info>
					</div>
				</div>

				<div class="row margin-top-sm">
					<div class="col-6">
						<view-child-enrollment [studentId]="studentId1"
							[studentHelperNumber]="1"></view-child-enrollment>
					</div>
					<div class="col-6">
						<view-child-enrollment [studentId]="studentId2"
							[studentHelperNumber]="2"></view-child-enrollment>
					</div>
				</div>

				<div class="row margin-top-sm">
					<div class="col-6">
						<view-child-eligibility-status [studentId]="studentId1"></view-child-eligibility-status>
					</div>
					<div class="col-6">
						<view-child-eligibility-status [studentId]="studentId2"></view-child-eligibility-status>
					</div>
				</div>

				<div class="row margin-top-sm">
					<div class="col-6">
						<view-child-move-history [studentId]="studentId1"></view-child-move-history>
					</div>
					<div class="col-6">
						<view-child-move-history [studentId]="studentId2"></view-child-move-history>
					</div>
				</div>

				<div class="row margin-top-sm">
					<div class="col-6">
						<view-child-service-participation [studentId]="studentId1"
							[studentHelperNumber]="1"></view-child-service-participation>
					</div>
					<div class="col-6">
						<view-child-service-participation [studentId]="studentId2"
							[studentHelperNumber]="2"></view-child-service-participation>
					</div>
				</div>
			</div>
		</mat-card-content>
	</div>
</div>